export default function ImageBanner({ image, alt = "" }) {
  return (
    <img
      className="size-full object-cover"
      src={image}
      alt={alt}
    />
  );
}
